import { render, staticRenderFns } from "./DevicePagination.vue?vue&type=template&id=dc4b20ce"
import script from "./DevicePagination.vue?vue&type=script&lang=js"
export * from "./DevicePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports